import { QUERY_KEYS } from 'api/query-keys';
import { availabilityService } from 'api/services';
import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import { WorkerAvailabilityQueryResult } from './month-availability-query.types';

export const useGetWorkerAvailability = (
  workerId: string,
  fromDate: DateTime,
  toDate: DateTime
): WorkerAvailabilityQueryResult => {
  const transformedFromDate = fromDate.toISODate();
  const transformedToDate = toDate.toISODate();
  const query = useQuery({
    queryKey: QUERY_KEYS.workerAvailability(workerId, transformedFromDate),
    queryFn: async () =>
      await availabilityService.getWorkerAvailability(
        workerId,
        transformedFromDate,
        transformedToDate
      ),
    enabled: !!workerId,
  });
  return query;
};
